import {
    SUPPLIER_INFO_LIST,
    SUPPLIER_INFO_LIST_SUCCESS,
    SUPPLIER_INFO_LIST_ERROR,
    SUPPLIER_INFO_LIST_SEARCH_SET,
    SUPPLIER_INFO_LIST_SEARCH_CHANGE
} from '../actions';

const INIT_STATE = {
    loading: true,
    list: {
        loading: true,
        message: ''
    },
    error: false,
    search: {
        modal: false,
        init: true,
        data: {
            idcode22: false,
            idcode22_country: false,
            idsupplier: false,
            idcountry: false
        },
        value: {
            idcode22: false,
            idcode22_country: false,
            idsupplier: false,
            idcountry: false
        }
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SUPPLIER_INFO_LIST:
            return {
                ...state,
                loading: true,
                list: {
                    ...state.list
                }
            }
        case SUPPLIER_INFO_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case SUPPLIER_INFO_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case SUPPLIER_INFO_LIST_SEARCH_SET:
            return {
                ...state,
                search: {
                    ...state.search,
                    data: action.payload,
                }
            }
        case SUPPLIER_INFO_LIST_SEARCH_CHANGE:
            return {
                ...state,
                search: {
                    ...state.search,
                    value: action.payload,
                }
            }
        default:
            return { ...state };
    }
};